import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';

import { CreateButton, SaveButton, CancelButton } from '../../components/buttons';

import { Layout, MinMaxLayout } from '../../layouts';
import { CountButton } from '../../components/buttons';

import AccountContent from './account-content';

function Welcome() {
    return (
        <div className="website-topbar__welcome">
            <p>Manage</p>
            <h3>My Account</h3>
        </div>
    )
}

class Account extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {},
            validation: [],
            crumbs: [
                {
                    name: 'Account',
                    link: '/account'
                },
                {
                    name: 'First Name',
                    link: '#'
                }
            ]
        };

        this.ref = null;

        this.saveHandler =  () => console.error('No save handler set');

        this.topRight = (
            <div class="website-row">
                <SaveButton onClick={()  => this.saveHandler()} />
                <CancelButton onClick={this.goBack}>Back</CancelButton>
            </div>
        )
    }

    getError(name) {
        return this.state.validation.find(e => e.name == name)?.errors || [];
    }

    setValidation(validation) {
        this.setState({ validation })
    }

    addError(errorBoolean, errors, name) {
        let state = [ ...this.state.validation ]

        if (errorBoolean) {
            const val = state.find(s => s.name == name);

            if (val) {
                val.errors = errors;
            } else {
                state.push({ name, errors });
            }
        } else {
            state = state.filter(s => s.name !== name);
        }

        this.setValidation(state)
    }


    handleUpdate() {

    }

    setSaveHandler(handler) {
        this.saveHandler = handler;
    }



    goBack() {
        window.history.back();
    }

    render() {
        const { errors } = this.state;
        const { user } = this.state;

        return (
            <Layout topLeft={<Welcome />} topRight={this.topRight}>
                <MinMaxLayout main={<AccountContent ref={this.ref} validation={this.state.validation} setValidation={this.setValidation.bind(this)} 
                                                    addError={this.addError.bind(this)} getError={this.getError.bind(this)} onSaveSet={this.setSaveHandler.bind(this)} />} />
            </Layout>
        );
    }
}

export default Account;

if (document.getElementById('account')) {
    ReactDOM.render(<Account/>, document.getElementById('account'));
}
